import {createAction, props} from '@ngrx/store';

export const ActionFailed = createAction('[Utility] Action Failed', props<{error: any}>());
